export const WIDTH       = "width";
export const HEIGHT      = "height";
export const TOP         = "top";
export const BOTTOM      = "bottom";
export const LEFT        = "left";
export const RIGHT       = "right";
export const hexBlack    = "#000";
export const transparent = hexBlack + "0";

export const mousemove   = "mousemove";
export const mousedown   = "mousedown";
export const mouseup     = "mouseup";
export const mouseenter  = "mouseenter";
export const mouseleave  = "mouseleave";
export const dblclick    = "dblclick";
export const resize      = "resize";
export const scroll      = "scroll";

export const change      = "change";
export const dppxchange  = "dppxchange";